__turbopack_context__.v({
  "variantContainer": "CheckBoxTypeAddonGroup-module-scss-module__x5ncDa__variantContainer",
});
